export const getNumberValue = (value: any) => {
  return value !== null && value !== undefined ? +value.toString().replaceAll(',',''): 0
}
